import { render } from "./IPNotification.vue?vue&type=template&id=35545c7d"
import script from "./IPNotification.vue?vue&type=script&lang=js"
export * from "./IPNotification.vue?vue&type=script&lang=js"

import "./IPNotification.vue?vue&type=style&index=0&id=35545c7d&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__